import axios from "axios";
import PAPI from "./patientsInstance";
import { Config } from "../Config";
import { notify, userAccessToken } from "../helpers";

export const fetchPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    last_visit,
    visit_day_query_type,
    visited_last_days,
    not_visited_last_days,
    risk_level,
    preventative_due,
    skip_self_pay,
    order_by,
    city,
    state,
    zip,
    patient_type,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";

    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }

    // const insuranceIds = insurance_ids ? `&insurance_ids=${insurance_ids}` : "";
    let visitedLastDays = visited_last_days
      ? `&visited_last_days=${visited_last_days}`
      : ``;
    let notVisitedLastDays = not_visited_last_days
      ? `&not_visited_last_days=${not_visited_last_days}`
      : "";
    let visitDayQueryType = visited_last_days || not_visited_last_days ? `&visit_day_query_type=${visit_day_query_type}` : ``;
    let riskLevel = risk_level ? `&risk_level=${risk_level}` : "";
    let preventativeDue = preventative_due
      ? `&preventative_due=${preventative_due}`
      : "";
    let skipSelfPay = skip_self_pay ? `&skip_self_pay=${skip_self_pay}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let sCity = city ? `&city=${city}` : "";
    let sState = state ? `&state=${state}` : "";
    let sZip = zip ? `&zip=${zip}` : "";
    let sStatus = patient_type ? `&patient_type=${patient_type}` : "";

    return PAPI.get(
      `/patients/get-patients-by-practice?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}&first_name=${first_name}&last_name=${last_name}&dob=${dob}&sex=${sex}&mobile_phone=${mobile_phone}${startAge}${endAge}${insuranceIds}&last_visit=${last_visit}${sCity}${sState}${sZip}${sStatus}${visitDayQueryType}${visitedLastDays}${notVisitedLastDays}${searchParam}${riskLevel}${preventativeDue}${skipSelfPay}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchInsuranceAsPractice = async (data) => {
  try {
    const response = await PAPI.post(`/insurances/list_by_practice`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchInsurance = async () => {
  try {
    return PAPI.get(`/insurances/list`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
  } catch (error) {}
};

export const fetchInsuranceCount = async () => {
  try {
    return PAPI.get(`/insurances/list/count`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
  } catch (error) {}
};

export const addPatients = async (formData) => {
  formData.colorectal_cs_time_period_months = 12

  try {
    const response = await PAPI.post(`/patients/create`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchSinglePatient = async (
  account_id,
  location_id,
  patient_id
) => {
  try {
    const response = await PAPI.get(
      `/patients/get-patients-with-care-gaps/single?account_id=${account_id}&location_id=${location_id}&patient_id=${patient_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchSingleSignoutPatient = async (
  account_id,
  location_id,
  waiting_room_id = null,
  retry = false,
  loader = true
) => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/waiting_room/previsit?account_id=${account_id}&location_id=${location_id}&waiting_room_id=${waiting_room_id}&retry=${retry}&loader=${loader}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const changePatientStatus = async (formData) => {
  try {
    const response = await PAPI.post(`/patients/change-status`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const exportPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    last_visit,
    visit_day_query_type,
    visited_last_days,
    not_visited_last_days,
    risk_level,
    preventative_due,
    skip_self_pay,
    order_by,
    city,
    state,
    zip,
    patient_type,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";

    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }
    let visitedLastDays = visited_last_days
      ? `&visited_last_days=${visited_last_days}`
      : ``;
    let notVisitedLastDays = not_visited_last_days
      ? `&not_visited_last_days=${not_visited_last_days}`
      : "";
    let visitDayQueryType = visited_last_days || not_visited_last_days ? `&visit_day_query_type=${visit_day_query_type}` : ``;
    let riskLevel = risk_level ? `&risk_level=${risk_level}` : "";
    let preventativeDue = preventative_due
      ? `&preventative_due=${preventative_due}`
      : "";
    let skipSelfPay = skip_self_pay ? `&skip_self_pay=${skip_self_pay}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let sCity = city ? `&city=${city}` : "";
    let sState = state ? `&state=${state}` : "";
    let sZip = zip ? `&zip=${zip}` : "";
    let sStatus = patient_type ? `&patient_type=${patient_type}` : "";

    return PAPI.get(
      `/patients/export-patients-by-practice?account_id=${account_id}&location_id=${location_id}&page=1&per_page=${per_page}&first_name=${first_name}&last_name=${last_name}&dob=${dob}&sex=${sex}&mobile_phone=${mobile_phone}${startAge}${endAge}${insuranceIds}&last_visit=${last_visit}${sCity}${sState}${sZip}${sStatus}${visitDayQueryType}${visitedLastDays}${notVisitedLastDays}${searchParam}${riskLevel}${preventativeDue}${skipSelfPay}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const getPatientCounselling = async ( account_id, location_id, patient_id ) => {
  try {
    // const result = {data: [{
    //   "name": "Obesity",
    //   "dos": "2023-10-26",
    //   "is_eligible": true
    // }]}
    // return result;
    const response = await axios.get(
      `${Config.apiServerUrl}/counselling/get-patient-counselling?account_id=${account_id}&location_id=${location_id}&patient_id=${patient_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchPatientOutreachInfo = async (filter) => {
  const { patient_id, account_id, location_id } = filter;
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/patient-notification-history/${patient_id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  }  catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching patient outreach info data.",
    };
  }
};

export const createNote = async ({ account_id, location_id, patient_id, notes }) => {
  const requestBody = {
    account_id,
    location_id,
    patient_id,
    notes,
  };

  try {
    const response = await PAPI.post(`/create_notes`, requestBody, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response.data; // Return the response data for further use
  } catch (error) {
    console.error("Error creating note:", error.response?.data || error.message);
    throw error.response?.data || error.message; // Throw the error for error handling in the caller
  }
};

export const getAllNotes = async (account_id, patient_id) => {
  try {
    const response = await axios.get(
      `${Config.patientServerUrl}/patients/get_notes?account_id=${account_id}&patient_id=${patient_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching notes:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching notes.",
    };
  }
};

export const getLastDataUpdatedTime = async (account_id, location_id) => {
  if (account_id === 0) {
    return false;
  }
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/patient-encounters/last-updated-dos/?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    const latestDos = response?.data?.latest_dos;
    const [year, month, day] = latestDos.split("-");
    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  } catch (error) {
    // if (error.response?.status === 404) {
      return "Never";
    // }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching notes.",
    };
  }
};

export const fetchVisitedPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    last_visit,
    not_visited_last_days,
    skip_self_pay,
    order_by,
    city,
    state,
    zip,
    patient_type,
  } = filter;

  try {
    let sFirstName = first_name ? `&first_name=${first_name}` : "";
    let sLastName = last_name ? `&last_name=${last_name}` : "";
    let sDOB = dob ? `&dob=${dob}` : "";
    let sSex = sex ? `&sex=${sex}` : "";
    let sPhone = mobile_phone ? `&mobile_phone=${mobile_phone}` : "";
    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }

    // const insuranceIds = insurance_ids ? `&insurance_ids=${insurance_ids}` : "";
    let visitDayQueryType = `&visit_day_query_type=1`;
    let visitedLastDays = not_visited_last_days ? `&visited_last_days=${not_visited_last_days}` : ``;
    let skipSelfPay = skip_self_pay ? `&skip_self_pay=${skip_self_pay}` : "";
    let sLastVisit = last_visit ? `&last_visit=${last_visit}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let sCity = city ? `&city=${city}` : "";
    let sState = state ? `&state=${state}` : "";
    let sZip = zip ? `&zip=${zip}` : "";
    let sStatus = patient_type ? `&patient_type=${patient_type}` : "";

    return PAPI.get(
      `/patients/get-patients-by-practice?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${sFirstName}${sLastName}${sDOB}${sSex}${sPhone}${startAge}${endAge}${insuranceIds}${sLastVisit}${sCity}${sState}${sZip}${sStatus}${visitDayQueryType}${skipSelfPay}${orderBy}${visitedLastDays}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  }  catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching patients data.",
    };
  }
};


export const fetchAnnualWellnessPatients = async (filter) => {
  const { account_id,location_id,care_gap_id,skip_self_pay } = filter;
  let skipSelfPay = skip_self_pay ? skip_self_pay : true;
  let careGapID= care_gap_id ? care_gap_id: 13

  try {
    return PAPI.get(
      `/patients/get-annual-wellness-all-patients?location_id=${location_id}&account_id=${account_id}&care_gap_id=${careGapID}&skip_self_pay=${skipSelfPay}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  }  catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching annual wellness patients data.",
    };
  }
};


export const fetchAllLocations = async (account_id) => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/locations_under_account/${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  }  catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching patient AllLocations data.",
    };
  }
};

export const changePatientLocationStatus = async (formData) => {
  try {
    const response = await PAPI.patch(`/patients/update-location`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};


export const sendWaitingRoomMails = async (data) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/waiting_room/summary_report`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchGeneratePatientsData = async (data) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/waiting_room/summary_report`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchSyncVeradigm = async (
  account_id,
  location_id
) => {
  try {
    axios.get(
      `${Config.apiServerUrl}/get_patients_from_ehr?account_id=${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    notify("success", "Patients data fetch triggered successfully.");
  } catch (error) {
    notify("error", "An error occurred while triggering patients data fetch.");
  }
};